import ApiClient from "../../../../../services/ApiClient2";

const cancelTokens = {
    fetchFooterTemplates: undefined,
    fetchFooters: undefined,
}

export function fetchFooterTemplates() {
    if (undefined !== cancelTokens.fetchFooterTemplates) {
        cancelTokens.fetchFooterTemplates = cancelTokens.fetchFooterTemplates.cancel();
    }
    cancelTokens.fetchFooterTemplates = ApiClient.createCancelToken();
    return ApiClient.query('/mailbox/template/footer/all', {pageSize: 50}, {
        cancelToken: cancelTokens.fetchFooterTemplates.token
    });
}

export function fetchFooters() {
    if (undefined !== cancelTokens.fetchFooters) {
        cancelTokens.fetchFooters = cancelTokens.fetchFooters.cancel();
    }
    cancelTokens.fetchFooters = ApiClient.createCancelToken();
    return ApiClient.query(`/mailbox/footer/`, {}, {
        cancelToken: cancelTokens.fetchFooters.token
    })
}

export function setDefault(uuid) {
    return ApiClient.put(`/mailbox/footer/${uuid}/default`);
}

export function addFooter(payload) {
    return ApiClient.post(`/mailbox/footer/`, payload);
}

export function updateFooter(uuid, payload) {
    return ApiClient.put(`/mailbox/footer/${uuid}`, payload);
}

export function deleteFooter(uuid) {
    return ApiClient.delete(`/mailbox/footer/${uuid}`);
}